/*
 * File: /src/router/routes/emails.js
 * Created Date: Thursday June 6th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 6th June 2019 12:42:55 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
const TemplateList = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/TemplateList.vue'
  );
const EmailList = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/EmailList.vue'
  );
const EmailGallery = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/EmailGallery.vue'
  );
const Editor = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/Editor.vue'
  );
const EmailEditor = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/EmailEditor.vue'
  );
const SmsEditor = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/SMS/SmsEditor.vue'
  );
const PostcardEditor = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/PostCard/PostcardEditor.vue'
  );
const View = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/TemplateView.vue'
  );
const Gallery = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/TemplateGallery.vue'
  );

const PostcardTemplateList = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/PostCard/PostcardList.vue'
  );

//
const TemplateSmsChat = () =>
  import(
    /* webpackChunkName: "Templates" */ 'src/components/Dashboard/Views/Templates/TemplateSmsChatEditor.vue'
  );

export const templateRoutes = [
  {
    path: 'templates/list/:type?/:folderId?',
    name: 'Templates',
    component: TemplateList,
    props: true,
  },
  {
    // FIXME: consider a rename to [email-list]
    path: 'templates/list-emails/:folderId?',
    name: 'Email Templates',
    component: EmailList,
    props: true,
  },
  {
    path: 'templates/email-gallery',
    name: 'Email Gallery',
    component: EmailGallery
  },
  {
    path: 'templates/list-postcards/:folderId?',
    name: 'Postcard Templates',
    component: PostcardTemplateList,
    props: true,
  },
  {
    path: 'templates/edit/:type/:id?',
    name: 'Template Editor',
    component: Editor,
    props: (route) => ({
      id: parseInt(route.params.id),
      type: route.params.type,
    }),
  },
  {
    path: 'email-templates/:id?',
    name: 'Email Editor',
    component: EmailEditor,
  },
  {
    path: 'templates/sms-edit/:id?',
    name: 'SMS Template Editor',
    component: SmsEditor,
  },
  {
    path: 'templates/postcard-edit/:id?',
    name: 'Postcard Template Editor',
    component: PostcardEditor,
  },
  {
    path: 'templates/view/:type/:id?',
    name: 'Template View',
    component: View,
  },
  {
    path: 'templates/gallery',
    name: 'Template Gallery',
    component: Gallery,
  },
  {
    path: 'templates/sms-chat',
    name: 'SMS Chat Templates',
    component: TemplateSmsChat,
  },
];
